<div class="white-bg-overlay">&nbsp;</div>
<section class="left-nav-wrapper scroll-container">
  <div class="d-flex mb-3">
    <div class="me-auto">
      <h1>People</h1>
    </div>
    <lib-people-search-bar></lib-people-search-bar>
    <button
      cpGTagEvent
      [params]="{ event_label: 'people_list_add_person' }"
      routerLink="/client/{{ clientCode }}/person/add"
      class="btn btn-primary ms-3"
      [disabled]="disableAddPersonButton">
      <i class="fas fa-xs fa-plus"></i>&nbsp;Add Employee/Contractor
    </button>
  </div>
  <ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="active">
    <li [ngbNavItem]="1">
      <a ngbNavLink class="tab-title"><h5>All</h5></a>
      <ng-template ngbNavContent>
        <lib-people-table [clientCode]="clientCode" [status]="null"></lib-people-table>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink class="tab-title"><h5>Active</h5></a>
      <ng-template ngbNavContent>
        <lib-people-table [clientCode]="clientCode" [status]="'ACTIVE'"></lib-people-table>
      </ng-template>
    </li>
    <li [ngbNavItem]="3">
      <a ngbNavLink class="tab-title"><h5>Inactive</h5></a>
      <ng-template ngbNavContent>
        <lib-people-table [clientCode]="clientCode" [status]="'INACTIVE'"></lib-people-table>
      </ng-template>
    </li>
    <li [ngbNavItem]="4">
      <a ngbNavLink class="tab-title"><h5>Terminated</h5></a>
      <ng-template ngbNavContent>
        <lib-people-table [clientCode]="clientCode" [status]="'TERMINATED'"></lib-people-table>
      </ng-template>
    </li>
  </ul>
  <br />
  <div [ngbNavOutlet]="nav"></div>
</section>
